/**
 * The options for the Charts
 */
export const Configs = {
    config_donut : {
        "title": "",
        "resizable": true,
        "donut": {
            "center": {
                "label": "Reservierungen"
            },
            "alignment": "center"
        },
        "toolbar": {
            "enabled": false,
        },
        "tooltip" : {
            "truncation": {
                "threshold": 124
            }
        },
        "legend": {
            "alignment": "center"
        },
        "height": "300px"
    },

    config_donut_types : {
        "title": "",
        "resizable": true,
        "donut": {
            "center": {
                "label": "Aktionen"
            },
            "alignment": "center"
        },
        "toolbar": {
            "enabled": false
        },
        "tooltip" : {
            "truncation": {
                "threshold": 124
            }
        },
        "legend": {
            "alignment": "center"
        },
        "height": "300px"
    },


    options_line: {
        "title": "",
        "axes": {
            "bottom": {
                "title": "Datum",
                "mapsTo": "date",
                "scaleType": "time",
                "ticks" : {
                    "formatter" :  d => d.toLocaleDateString("de-De", { 
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                }
            },
            "left": {
                "mapsTo": "value",
                "title": "Anzahl",
                "scaleType": "linear"
            }
        },
        "legend": {
            "alignment": "center"
        },
        "zoomBar": {
            "updateRangeAxis": true,
            "zoomRatio": 1.0,
            "top": {
                "enabled": false,
            },
        },
        "toolbar": {
            "enabled": false,
        },
        "tooltip" : {
            "truncation": {
                "threshold": 124
            },
            "groupLabel": "Gruppe",


            "valueFormatter" :  d => d.toLocaleString()
        },
        "curve": "curveMonotoneX",
        "height": "400px"
    },

    


    data_radar : [

    ],
    options_radar : {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl",
            },
            "bottom": {
                "scaleType": "labels",
                "mapsTo": "key",
                "title": "Art",
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        },
        "tooltip": {
            "groupLabel": "Aktion",
            "showTotal": true,
            "truncation": {
                "threshold": 124
            }
        },
        "resizable": true,
        "height": "400px"
    },

    options_line_simple : {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                "title": "Kategorie",
            }
        },
        "tooltip": {
            "groupLabel": "Kategorie",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        },
        "resizable": true,
        "height": "400px"
    },

    options_line_partners:  {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                "title": "Partner",
            }
        },
        "tooltip": {
            "groupLabel": "Partner",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        },
        "resizable": true,
        "height": "400px"
    },


    options_line_savings:  {
        "title": "",
        "axes": {
            "left": {
                "mapsTo": "value",
                "title": "Anzahl"
            },
            "bottom": {
                "mapsTo": "group",
                "scaleType": "labels",
                "title": "Preisnachlass in %",
            }
        },
        "tooltip": {
            "groupLabel": "Preisnachlass in %",
            "truncation": {
                "threshold": 124
            }
        },
        "toolbar": {
            "enabled": false,
        },
        "legend": {
            "alignment": "center"
        },
        "resizable": true,
        "height": "400px"
    }
    
}